export interface addItem {
    toBeAdded: string;
    toBeAddedAfter: string;
    toBeAddedBefore: string;
    keyword?: string;
    indent?: number;
    exactMatch?: boolean;
    wholeLine?: boolean;
    connector?: string;
    needImportHandler?: boolean;
}
